import * as i0 from '@angular/core';
import { Pipe } from '@angular/core';
import * as i1 from '@angular/platform-browser';
let SafePipe = /*#__PURE__*/(() => {
  class SafePipe {
    constructor(sanitizer) {
      this.sanitizer = sanitizer;
    }
    transform(value, type) {
      switch (type) {
        case 'html':
          return this.sanitizer.bypassSecurityTrustHtml(value);
        case 'style':
          return this.sanitizer.bypassSecurityTrustStyle(value);
        case 'script':
          return this.sanitizer.bypassSecurityTrustScript(value);
        case 'url':
          return this.sanitizer.bypassSecurityTrustUrl(value);
        case 'resourceUrl':
          return this.sanitizer.bypassSecurityTrustResourceUrl(value);
        default:
          throw new Error(`SafePipe unable to bypass security for invalid type: ${type}`);
      }
    }
    static {
      this.ɵfac = function SafePipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SafePipe)(i0.ɵɵdirectiveInject(i1.DomSanitizer, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "safe",
        type: SafePipe,
        pure: true
      });
    }
  }
  return SafePipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of safe-pipe
 */

/**
 * Generated bundle index. Do not edit.
 */

export { SafePipe };
